module.exports = __webpack_public_path__ + "static/step1_203-9b18657d25952748341bc1605e0934be.png";